<template>
  <div class="h-screen pt-16">
    <div class="flex items-center w-full h-full">
      <div
        class="relative flex w-10/12 px-8 py-32 mx-auto my-auto text-3xl shadow-2xl rounded-box h-5/6 bg-base-100 text-base-content ring-1 ring-primary"
      >
        <div class="absolute top-0 -left-0">
          <img class="w-48 scale-x-[-1]" src="/img/help.png" />
          <div
            class="absolute flex flex-col gap-y-1 top-10 rotate-[70deg] left-36"
          >
            <div class="w-6 h-6 rounded-full bg-neutral"></div>
            <div class="w-4 h-4 rounded-full bg-neutral"></div>
            <div class="w-2 h-2 rounded-full bg-neutral"></div>
          </div>

          <span
            class="absolute -ml-2 text-base w-72 top-4 card bg-neutral text-neutral-content left-48"
          >
            <div class="p-2 text-center card-body">
              Salut {{ $user ? $user.getUser.userName : "" }} !! je suis votre
              assistante virtuelle. En cas de besion cliquez sur moi
            </div>
          </span>
        </div>

        <button
          @click="$router.push('/app/folders')"
          class="absolute flex items-center justify-center btn btn-secondary btn-square btn-lg btn-circle bottom-5 animate-bounce right-5"
        >
          <svg style="width: 48px; height: 48px" viewBox="0 0 24 24">
            <path
              fill="currentColor"
              d="M21,9A1,1 0 0,1 22,10A1,1 0 0,1 21,11H16.53L16.4,12.21L14.2,17.15C14,17.65 13.47,18 12.86,18H8.5C7.7,18 7,17.27 7,16.5V10C7,9.61 7.16,9.26 7.43,9L11.63,4.1L12.4,4.84C12.6,5.03 12.72,5.29 12.72,5.58L12.69,5.8L11,9H21M2,18V10H5V18H2Z"
            />
          </svg>
        </button>
        <div
          class="flex flex-col justify-center hidden w-1/2 h-full tracking-wide text-center logo-font"
        >
          <h1
            class="mb-4 text-4xl font-bold text-center logo-font text-primary"
          >
            Description du module
          </h1>
          {{ currentModule.moduleDescription }}
        </div>
        <div class="hidden divider divider-vertical"></div>
        <ol
          class="flex flex-col justify-center w-10/12 h-full pl-8 mx-auto list-decimal "
        >
          <h1
            class="mb-4 text-4xl font-bold text-center logo-font text-primary"
          >
            Demarche du module
          </h1>
          <li
            class="text-xl font-bold logo-font"
            v-for="(item, index) in currentModule.moduleDemarche"
            :key="index"
          >
            {{ item.title ?? item }}
            <ul v-if="item.subs">
              <li
                class="ml-8 list-disc logo-font"
                v-for="(sub, index) in item.subs"
                :key="index"
              >
                {{ sub }}
              </li>
            </ul>
          </li>
        </ol>
      </div>
    </div>
  </div>
</template>

<script>
import authMixin from "@/utils/mixins/auth.mixin.js";
export default {
  name: "PageDescription",
  mixins: [authMixin],

  mounted() {
    this.$store.commit(
      "setCurrentModule",
      JSON.parse(localStorage.getItem("currentModule"))
    );
  },
  computed: {
    currentModule() {
      return this.$store.state.currentModule;
    }
  }
};
</script>

<style></style>
